<template>
  <div>
    <Head :title="$t('actions.create_model', [$t('models.member')])"/>

    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.members.index')">
          {{ $t('models.member') }}
        </Link>
        <span class="text-indigo-400 font-medium mx-2">/</span>
        {{ $t('ui.create') }}
      </h1>
      <div class="ml-auto">
        <Link class="btn-indigo" :href="route('admin.members.index')">
          <span>{{ $t('ui.back') }}</span>
        </Link>
      </div>
    </div>

    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.membership_number" :error="form.errors.membership_number"
                      class="pb-8 pr-6 w-full lg:w-1/6"
                      :label="$t('fields.member.membership_number')" autofocus/>
          <text-input v-model="form.join_date" :error="form.errors.join_date"
                      class="pb-8 pr-6 w-full lg:w-2/6" :placeholder="dateInputPlaceholder"
                      :label="$t('fields.member.join_date')"/>
          <text-input v-model="form.nric" :error="form.errors.nric"
                      class="pb-8 pr-6 w-full lg:w-3/6" :label="$t('fields.member.nric')"/>
          <text-input v-model="form.full_name" :error="form.errors.full_name"
                      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('fields.member.full_name')"/>
          <text-input v-model="form.full_name_cn" :error="form.errors.full_name_cn"
                      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('fields.member.full_name_cn')"/>
          <text-input v-model="form.mobile" :error="form.errors.mobile"
                      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('fields.member.mobile')"/>
          <text-input v-model="form.email" :error="form.errors.email" type="email"
                      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('fields.member.email')"/>
          <select-input v-model="form.gender" :error="form.errors.gender"
                        class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('fields.member.gender')">
            <option :value="null"/>
            <option v-for="gender in genders" :value="gender">{{ gender }}</option>
          </select-input>
          <text-input v-model="form.dob" :error="form.errors.dob"
                      class="pb-8 pr-6 w-full lg:w-1/2" :placeholder="dateInputPlaceholder"
                      :label="$t('fields.member.dob')"/>
          <textarea-input v-model="form.address" :error="form.errors.address" rows="3"
                          class="pb-8 pr-6 w-full" :label="$t('fields.member.address')"/>
          <text-input v-model="form.state" :error="form.errors.state"
                      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('fields.member.state')"/>
          <select-input v-model="form.is_active" :error="form.errors.is_active"
                        class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('fields.member.is_active')">
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select-input>
          <textarea-input v-model="form.remarks" :error="form.errors.remarks" rows="3"
                          class="pb-8 pr-6 w-full" :label="$t('fields.member.remarks')"/>
          <file-input v-model="form.photo" :error="form.errors.photo"
                      class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*"
                      label="Photo"/>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            Create Member
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Layouts/Authenticated'
import FileInput from '@/Inputs/FileInput'
import TextInput from '@/Inputs/TextInput'
import SelectInput from '@/Inputs/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from "@/Inputs/TextareaInput";

export default {
  components: {
    TextareaInput,
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  props: {
    genders: Array,
    states: Array,
    regions: Array,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        membership_number: '',
        join_date: '',
        nric: '',
        full_name: '',
        full_name_cn: '',
        mobile: '',
        email: '',
        gender: null,
        dob: '',
        address: '',
        state: '',
        region: '',
        remarks: '',
        is_active: '1',
        photo: null,
      }),
      dateInputPlaceholder: `e.g. ${new Date().toLocaleDateString('en-CA')}`,
    }
  },
  methods: {
    store() {
      this.form.post(route('admin.members.store'))
    },
  },
}
</script>
